webpackJsonp([72],{

/***/ 1251:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1252);


/***/ }),

/***/ 1252:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(157);

var _datetime2 = _interopRequireDefault(_datetime);

var _pt = __webpack_require__(753);

var _pt2 = _interopRequireDefault(_pt);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('pt', _pt2.default);

/***/ })

},[1251]);


// WEBPACK FOOTER //
// app/datetime.pt-43e29cf05b360009f068.js